import { IsDevEnv, TestPanel } from '@/app'

/**
 * Where LinkedIn sends the browser back to.
 *
 * Shared by the button that starts the flow and by the token exchange that finishes it:
 * LinkedIn checks that the two are identical, so they cannot be two literals that happen to
 * agree today.
 */
export function getRedirectUri() {
  const baseUrl = IsDevEnv ? 'http://localhost:8000' : TestPanel.getWebsiteUrl().replace(/\/$/, '')

  return `${baseUrl}/auth/linkedIn/`
}
